(function () {
  angular.module('MktzapApp.Controllers')
    .controller('LangController', langController);

  langController.$inject = ['$scope', 'FoundationApi', 'ngTableParams', 'LangService', 'NotificationService', '$rootScope'];

  function langController ($scope, FoundationApi, ngTableParams, LangService, NotificationService, $rootScope) {
    var vm = this;
    vm.script = '';
    vm.edit = edit;
    vm.add = add;
    vm.backup = backup;
    vm.searchLangTable = searchLangTable;
    vm.saveLang = saveLang;
    vm.totalLang = 0;
    vm.action = ''
    vm.langSelected = {}
    vm.labels = {}

    vm.filters = {
      page: ''
    }

    LangService
      .getPageLabels({ 'page': 'menu.master.langs' })
      .$promise
      .then(function (data) {
          vm.labels = data.lang
      })

    searchLangTable();

    function searchLangTable () {
      vm.langTable = new ngTableParams({
        count: 50
      }, {
        counts: [25, 50, 100],
        getData: function ($defer, params) {
          var obj = params.url();
          var keys = Object.keys(vm.filters);

          for (var i = 0; i < keys.length; i++) {
            var filterValue = vm.filters[keys[i]]
            if (filterValue != null && filterValue !== '') {
              obj['filter[' + keys[i] + ']'] = filterValue
            }
          }

          LangService
            .getLangs(obj)
            .$promise
            .then(function (data) {
              $defer.resolve(data.lang.result);
              if (data.lang.success) {
                vm.totalLang = data.lang.result.length;
              } else {
                NotificationService.errorHandler(data, 'Erro durante a comunicação com a API!');
                vm.totalLang = 0;
              }
            }).catch(function (data) {
              NotificationService.errorHandler(data, 'Erro ao carregar as Langs!');
              vm.totalLang = 0;
            });
        }
      });
    }

    function saveLang () {
      try {
        if (vm.script !== '') {
          obj = { 'lang': JSON.parse(vm.script) };
          LangService
            .saveLang(obj)
            .$promise
            .then(function (data) {
              searchLangTable();
              NotificationService.successHandler(data, 'Lang salva com sucesso!');
              FoundationApi.publish('langModal', 'close');
            }).catch(function (data) {
              NotificationService.errorHandler(data, 'Erro ao salvar Lang!');
            })
        } else {
          NotificationService.errorHandler('Nenhum dado informado!', 'Nenhum dado informado!');
        }
      } catch (data) {
        NotificationService.errorHandler(data, 'Lang inválida!');
      }
    }

    $scope.updateLangObject = function () {
      if (vm.script !== '') {
        try {
          $scope.message = JSON.parse(vm.script);
          $scope.formatting = { color: 'green', 'background-color': '#d0e9c6' };
          vm.langValid = true;
        } catch (e) {
          $scope.formatting = { color: 'red', 'background-color': '#f2dede' };
          vm.langValid = false;
        }
      } else {
        $scope.formatting = {};
      }
    };

    function add () {
      vm.action = 'add'
      vm.langSelected = {}
      document.getElementById('scriptMongoDB').readOnly = false;
      vm.backupDialog = false;
      vm.script = '';
      FoundationApi.publish('langModal', 'open');
      $scope.updateLangObject();
    }

    function edit (lang) {
      vm.action = 'edit'
      vm.langSelected = lang
      document.getElementById('scriptMongoDB').readOnly = false
      vm.backupDialog = false
      vm.script = JSON.stringify(lang, null, 2)
      $scope.updateLangObject()
      FoundationApi.publish('langModal', 'open')
    }

    function backup () {
      vm.backupDialog = true;
      document.getElementById('scriptMongoDB').readOnly = true;

      LangService
        .getLangs()
        .$promise
        .then(function (data) {
          data.lang.result.forEach(function (lang) {
            delete lang['_id'];
            delete lang['createdAt'];
          });

          dumpDB = data.lang.result.map(function (e) {
            return JSON.stringify(e, null, 2);
          });
          vm.script = dumpDB;
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao carregar as Langs!');
        });

      FoundationApi.publish('langModal', 'open');
    }

    vm.cleanSearch = function () {
      if (vm.filters.page !== '') {
        vm.filters.page = '';
        searchLangTable();
      }
      
      return null;
    }

    vm.copy = function () {
      var element = angular.element('#scriptMongoDB');
      element.select();
      document.execCommand('copy');
    }
  }
})();
